import { render, staticRenderFns } from "./productionSubcontract-add-or-update.vue?vue&type=template&id=5a2e788f&scoped=true"
import script from "./productionSubcontract-add-or-update.vue?vue&type=script&lang=js"
export * from "./productionSubcontract-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./productionSubcontract-add-or-update.vue?vue&type=style&index=0&id=5a2e788f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2e788f",
  null
  
)

export default component.exports